const { getRoleBaseDashboardPath, constructMicroAppUrl } = useNavigation();

export default defineNuxtRouteMiddleware((to) => {
  if (process.server) {
    const event = useRequestEvent();
    const userRole = event?.context.session?.role;

    const dashboardPath = getRoleBaseDashboardPath(userRole);

    // if dashboard url not found, then let user access the page
    if (!dashboardPath) return;

    // construct the full dashboard URL
    const redirectUrl = constructMicroAppUrl(
      [dashboardPath],
      useRuntimeConfig().public.microapps.urlContracts.dashboard
    );

    if (to.path !== redirectUrl) {
      return navigateTo(redirectUrl, {
        external: true
      });
    }
  }
});
